import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { DateTimePicker } from "../day-picker";
import { formatDate } from "../day-picker";

const AppointmentComp = (props: any) => {
    const { t, i18n } = useTranslation();      
    const selectLbl = i18n.exists("forms.selectLbl") ? t('forms.selectLbl') : "Моля изберете предпочитана от вас дата"; 
    const fillInfoLbl = i18n.exists("forms.fillInfoLbl") ? t('forms.fillInfoLbl') : "Въведете информация"; 
    const dateLbl = i18n.exists("forms.dateLbl") ? t('forms.dateLbl') : "Дата"; 
    const hourLbl = i18n.exists("forms.hourLbl") ? t('forms.hourLbl') : "Час"; 
    //Fill information
    const [userName, setUserName] = useState("");
    let [dTime, setDTime] = useState(Object);

    const getDateTime = (dateTime: any) => {
        dTime = dateTime;
        setDTime(dateTime);
        props.dateTime(dTime);
        console.log(dTime);
    }
    
    useEffect(() => {
        const user: any = localStorage.getItem('auth-user');
        const authUser = JSON.parse(user);
        const names = authUser.firstName && authUser.lastName ? authUser.firstName + " " + authUser.lastName : "";
        //console.log(authUser)
        setUserName(names);
    }, [])

    return (
        <div className="appointment-comp">
            <div className="progr">
                <div>
                    <div className="founder-heading">
                        <h3>{userName}</h3>
                    </div>
                    <div>
                        <p>{selectLbl}</p>
                    </div>
                    <div className="wizzard-select-date">
                        <p>{fillInfoLbl}</p>
                        <p> {dTime.date ? formatDate(dTime.date) : dateLbl}</p>
                        <p>{dTime.time ? dTime.time : hourLbl}</p>
                    </div>
                </div>
                <div className="date-out">
                    <DateTimePicker getData={getDateTime}/>
                </div>
            </div>
        </div>
    )
}

export default AppointmentComp;